import { IDistrict } from "./districts";
import { IStaffType } from './staff';

export interface ITrainingCard {
  id?: string;
  title: string;
  description: string;
  staffType: IStaffType;
  start: string;
  end: string;
  province: string;
  districts: Array<IDistrict>;
  capacity: number;
  comment?: string;
  inviteCode?: string;
  createdAt?: number;
  updatedAt?: number;
  status?: TrainingCardStatus; // 0 = open, 1 = full, 2 = started, 3 = ended, 4 = cancelled
  userHasApplied?: boolean;
  userApplicationStatus?: TrainingCardApplicationStatus;
  userDistrict?: IDistrict;
}

export interface ITrainingCardStaff {
  id?: string;
  trainingCardId: string;
  userId: string;
  district: string;
  createdAt?: number;
  modifiedAt?: number;
  status?: TrainingCardApplicationStatus;
}

export enum TrainingCardApplicationStatus {
  Pending = 0,
  Accepted = 1,
  Declined = 2,
  Completed = 3,
  Rated = 4
}

export enum TrainingCardStatus {
  Open = 0,
  Closed = 1
}



// WEBPACK FOOTER //
// ./src/interfaces/training-cards.ts